import React from 'react';

import { ModalLoadingPage } from 'APP_ROOT/components/common/loadingPage';

import CardMap from './CardMap';

export default class CardMapPanel extends React.Component {

    constructor(props) { 
        super(props);

    }

    onLiveStream = (cameraType, streamStartDate = null) => {

        this.props.onLiveStream({
            ravenUuid: this.props.ravenUuid,
            vehicleName: this.props.vehicleName,
            defaultCamera: cameraType,
            startDate: streamStartDate.getTime ? streamStartDate : new Date(streamStartDate)
        });
    }

    onCloseLiveStream = () => {
        this.setState({liveStream: false});
    }

    render() {
        const { card, header, theme, mapCenterFallback, loading } = this.props;
        const mapCenter = card && card.end ? card.end : mapCenterFallback;

        return (
            <div className="card-map-panel">
                {mapCenter && (
                    <CardMap
                        features={{}}
                        historicalStreamingEnabled={this.props.features ? this.props.features.historical_streaming : false}  // not a scalable prop, but very obvious for now
                        theme={theme}
                        setLayoutFullscreen={this.props.setLayoutFullscreen}
                        mapId="historyMap"
                        mapCenter={mapCenter}
                        mapZoom={15}
                        selectedEvent={this.props.selectedEvent}
                        ref={ref => { this.mapboxmap = ref }}
                        card={card}
                        ravenOffline={this.props.ravenOffline}
                        onLiveStream={this.onLiveStream}
                        canViewVideoStream={this.props.canViewVideoStream}
                    />
                )}
                {header}
                {loading && <div className="loading-overlay"><ModalLoadingPage style="light-theme-invert" /></div>}
            </div>
        );
    }

}
